/* eslint-disable simple-import-sort/imports */
import { Search } from '@mui/icons-material';
import { getLocalStorageItem } from 'hooks';
import { useUserBlastGroupListApiQuery } from 'queries/Users';
import { useSearchUser } from 'queries/Message';
import { useGetChatAllQuery } from 'queries/InternalChat';
import React, { useCallback, useEffect, useRef, useState } from 'react';

interface Chat {
  id: number;
  name: string;
  lastMessage: string;
  time: string;
  picture: string;
  statusId: string;
}

interface ChatListsProps {
  showChat: boolean;
  setShowChat: React.Dispatch<React.SetStateAction<boolean>>;
  selectedChat: Chat | undefined; // Corrected type
  setSelectedChat: React.Dispatch<React.SetStateAction<Chat | undefined>>;
}

const ChatLists: React.FC<ChatListsProps> = ({
  showChat,
  setShowChat,
  selectedChat,
  setSelectedChat,
}) => {
  const userData = getLocalStorageItem('roles');
  const { data: userBlastGroup } = useUserBlastGroupListApiQuery(
    userData?.account?.id
  );
  const { mutate: fetchUsers, data: searchedUser } = useSearchUser();
  const { mutate: fetchChats, data: allChats } = useGetChatAllQuery();
  console.log('allChats>>>>>>>>>', allChats);
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
  const tabs = ['Chats', 'Blast'];
  const [activeTab, setActiveTab] = useState(0);
  const [searchValue, setSearchValue] = useState('');

  const chatList = [
    {
      id: 1,
      name: 'Phoenix Baker',
      picture:
        'https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250', // Replace with actual image
      lastMessage:
        'Hey Olivia, Katherine sent me over the latest doc. I just have a quick question about the...',
      time: '5 min ago',
      statusId: 'A0B1C065',
    },
    {
      id: 2,
      name: 'Katherine Moss',
      picture:
        'https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250',
      lastMessage:
        'Hey Olivia, Katherine sent me over the latest doc. I just have a quick question about the...',
      time: '25 min ago',
      statusId: 'A0B1C065',
    },
    {
      id: 3,
      name: 'Coffee Gang',
      picture:
        'https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250',
      lastMessage:
        'Hey Olivia, Katherine sent me over the latest doc. I just have a quick question about the...',
      time: '20 min ago',
      statusId: 'A0B1C065',
    },
    {
      id: 4,
      name: 'Analah Whitten',
      picture:
        'https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250',
      lastMessage:
        'Hey Olivia, Katherine sent me over the latest doc. I just have a quick question about the...',
      time: '10 min ago',
      statusId: 'A0B1C065',
    },
    {
      id: 5,
      name: 'Coffee Gang',
      picture:
        'https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250',
      lastMessage:
        'Hey Olivia, Katherine sent me over the latest doc. I just have a quick question about the...',
      time: '21 min ago',
      statusId: 'A0B1C065',
    },
    {
      id: 6,
      name: 'Rosalee Melvin',
      picture:
        'https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250',
      lastMessage:
        'Hey Olivia, Katherine sent me over the latest doc. I just have a quick question about the...',
      time: '30 min ago',
      statusId: 'A0B1P035',
    },
    {
      id: 7,
      name: 'Analah Whitten',
      picture:
        'https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250',
      lastMessage:
        'Hey Olivia, Katherine sent me over the latest doc. I just have a quick question about the...',
      time: '40 min ago',
      statusId: 'A0D1C095',
    },
    {
      id: 8,
      name: 'Rosalee Melvin',
      picture:
        'https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250',
      lastMessage:
        'Hey Olivia, Katherine sent me over the latest doc. I just have a quick question about the...',
      time: '15 min ago',
      statusId: 'A0C1C075',
    },
    {
      id: 9,
      name: 'Katherine Moss',
      picture:
        'https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250',
      lastMessage:
        'Hey Olivia, Katherine sent me over the latest doc. I just have a quick question about the...',
      time: '25 min ago',
      statusId: 'A0B1C165',
    },
    {
      id: 10,
      name: 'Rosalee Melvin',
      picture:
        'https://media2.dev.to/dynamic/image/width=800%2Cheight=%2Cfit=scale-down%2Cgravity=auto%2Cformat=auto/https%3A%2F%2Fwww.gravatar.com%2Favatar%2F2c7d99fe281ecd3bcd65ab915bac6dd5%3Fs%3D250',
      lastMessage:
        'Hey Olivia, Katherine sent me over the latest doc. I just have a quick question about the...',
      time: '19 min ago',
      statusId: 'A0B1C067',
    },
  ];

  useEffect(() => {
    setSelectedChat(chatList[0]);
  }, []);

  useEffect(() => {
    fetchChats();
  }, []);

  const handleChange = useCallback((e: any) => {
    const name = e.target.value;
    setSearchValue(name);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      fetchUsers({ accountId: userData?.account?.id, name });
    }, 1000);
  }, []);

  const handleChatClick = (value: any) => {
    setSelectedChat(value);
    setShowChat(true);
  };

  const timeAgo = (timestamp: string | number | Date) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    const intervals = [
      { label: 'year', seconds: 31536000 },
      { label: 'month', seconds: 2592000 },
      { label: 'week', seconds: 604800 },
      { label: 'day', seconds: 86400 },
      { label: 'hour', seconds: 3600 },
      { label: 'minute', seconds: 60 },
      { label: 'second', seconds: 1 },
    ];

    const interval = intervals.find(({ seconds }) => diffInSeconds >= seconds);
    return interval
      ? `${Math.floor(diffInSeconds / interval.seconds)} ${interval.label}${
          Math.floor(diffInSeconds / interval.seconds) !== 1 ? 's' : ''
        } ago`
      : 'Just now';
  };

  return (
    <>
      <div
        className={`border-r bg-white lg:block ${
          showChat ? 'hidden' : 'block'
        }`}
        style={{ borderRight: '1px solid #D0D5DD' }}
      >
        <div
          className="mb-2 flex h-[40px] justify-between border-b "
          style={{ borderBottom: '1px solid #D0D5DD' }}
        >
          {tabs.map((tab, index) => (
            <p
              key={index}
              className={`m-0 mx-4 w-[100px] cursor-pointer border-0 bg-transparent px-4 py-2 text-center text-[16px] font-medium  ${
                activeTab === index
                  ? 'border-b-4 border-[#73B1E9] text-[#73B1E9]'
                  : 'border-b-0 text-gray-600'
              }`}
              onClick={() => setActiveTab(index)}
              style={
                activeTab === index
                  ? { borderBottom: '3px solid #73B1E9', color: '#73B1E9' }
                  : { borderBottom: '0px', color: 'gray' }
              }
            >
              {tab}
            </p>
          ))}
        </div>
        <div className="box-border h-[66px] w-full border-[#D0D5DD] px-4">
          <div
            className="flex  h-[44px] rounded-[8px]"
            style={{ border: '1px solid #D0D5DD' }}
          >
            <Search className="ml-2 mt-[12px] text-[#667085]" />
            <input
              type="text"
              placeholder="Search Chat"
              value={searchValue}
              onChange={handleChange}
              className="box-border w-full rounded-[8px] border-0 pl-2 focus:outline-none focus:ring-0"
            />
          </div>
        </div>
        {activeTab === 0 && (
          <div className="flex h-[calc(100vh-181px)] flex-col overflow-x-auto lg:h-[calc(100vh-141px)]">
            {chatList?.map((value: any, index) => {
              return (
                <div
                  key={index}
                  className={`${
                    selectedChat?.id === value.id ? 'bg-[#D3E7F9]' : ''
                  } max-h-[128px] cursor-pointer p-3`}
                  style={{ borderBottom: '1px solid #EAECF0' }}
                  onClick={() => handleChatClick(value)}
                >
                  <div
                    className={`${
                      selectedChat?.id === value?.id
                        ? 'bg-[#D3E7F9]'
                        : 'bg-white'
                    } flex items-start gap-2`}
                  >
                    {value?.picture ? (
                      <img
                        src={value?.picture}
                        alt="Profile"
                        className="h-10 w-10 rounded-full"
                      />
                    ) : (
                      <div className="flex h-10 w-10 items-center justify-center rounded-full border bg-[#73B1E9]">
                        <div className="text-[24px] font-medium text-white">
                          {value?.name?.charAt(0)?.toUpperCase()}
                        </div>
                      </div>
                    )}
                    <div className="flex-1">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="m-0 font-semibold text-gray-900">
                            {value?.name}
                          </p>
                          <p className="m-0 text-xs text-gray-500">
                            {value?.uuid?.slice(0, 8).toUpperCase()}
                          </p>
                        </div>
                        <p className="text-xs text-gray-400">5 min ago</p>
                      </div>
                      <p className="m-0 mt-1 text-sm text-gray-700">
                        Hey Olivia, Katherine sent me over the latest doc. I
                        just have a quick question about the...
                      </p>
                    </div>
                    <div className="flex flex-col items-center">
                      <span className="h-2 w-2 rounded-full bg-blue-500"></span>
                      <span className="bg-green-500 mt-1 h-3 w-3 rounded-full"></span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {activeTab === 1 && (
          <div className="flex h-[calc(100vh-181px)] flex-col overflow-x-auto lg:h-[calc(100vh-141px)]">
            {userBlastGroup?.length > 0 ? (
              userBlastGroup?.map((value: any, index: number) => {
                return (
                  <div
                    key={index}
                    className={`${
                      selectedChat?.id === value?.id ? 'bg-[#D3E7F9]' : ''
                    } max-h-[128px] cursor-pointer p-3`}
                    style={{ borderBottom: '1px solid #EAECF0' }}
                    onClick={() => handleChatClick(value)}
                  >
                    <div
                      className={`${
                        selectedChat?.id === value?.id
                          ? 'bg-[#D3E7F9]'
                          : 'bg-white'
                      } flex items-start gap-2`}
                    >
                      {value?.picture ? (
                        <img
                          src={value?.picture}
                          alt="Profile"
                          className="h-10 w-10 rounded-full"
                        />
                      ) : (
                        <div className="flex h-10 w-10 items-center justify-center rounded-full border bg-[#73B1E9]">
                          <div className="text-[24px] font-medium text-white">
                            {value?.name?.charAt(0)?.toUpperCase()}
                          </div>
                        </div>
                      )}
                      <div className="flex-1">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="m-0 font-semibold text-gray-900">
                              {value?.name}
                            </p>
                            <p className="m-0 text-xs text-gray-500">
                              {value?.uuid?.slice(0, 8)?.toUpperCase()}
                            </p>
                          </div>
                          <p className="text-xs text-gray-400">
                            {timeAgo(value?.createdAt)}
                          </p>
                        </div>
                        <p className="mt-1 text-sm text-gray-700">
                          {value?.description}
                        </p>
                      </div>
                      <div className="flex flex-col items-center">
                        <span className="h-2 w-2 rounded-full bg-blue-500"></span>
                        <span className="bg-green-500 mt-1 h-3 w-3 rounded-full"></span>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="flex justify-center">
                <p className="items-center text-[18px] text-[#73B1E9]">
                  No Blast Group Found!
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ChatLists;
